<div class="it-hero-wrapper it-wrapped-container" id="main-container">
  <div
    class="img-responsive-wrapper"
    *ngIf="data.field_image?.field_media_image?.uri?.url"
  >
    <div class="img-responsive">
      <div class="img-wrapper">
        <img
          [src]="data.field_image?.field_media_image?.uri?.url"
          [alt]="data.field_image?.field_media_image?.meta?.alt"
          [title]="data.field_image?.field_media_image?.meta?.title"
        />
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div
          class="it-hero-card it-hero-bottom-overlapping rounded px-lg-5 py-4 py-lg-5 shadow-sm"
        >
          <div class="row justify-content-center">
            <div class="col-12">
              <app-breadcrumbs
                [path]="data?.path?.alias"
                [mt_0]="true"
              ></app-breadcrumbs>
            </div>
          </div>
          <div class="row justify-content-between mt-lg-2">
            <div class="col-12 col-lg-8 pl-lg-8">
              <h1 class="mb-3">{{ data.title }}</h1>
              <h2 class="visually-hidden" id="news-details">
                Dettagli della notizia
              </h2>
              <p class="text-secondary">
                {{ data.tag_body?.summary }}
              </p>
              <p [innerHTML]="data.tag_body?.processed"></p>
              <div class="row pt-4">
                <ul class="d-flex flex-wrap gap-1">
                  <li *ngFor="let tag of data.tag_related_tags">
                    <a
                      class="chip chip-simple"
                      [href]="tag?.path?.alias"
                      data-focus-mouse="false"
                    >
                      <span class="chip-label">{{ tag.title }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-3 pt-5 pt-lg-0">
              <app-social-share [url]="data?.path?.alias"></app-social-share>
              <app-actions-list
                [mailObject]="data?.title"
                [path]="data?.path?.alias"
              ></app-actions-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngFor="let band of horizontalBands">
  <app-horizontal-band
    [identifier]="band.identifier"
    [headingText]="band.headingText"
    [showAllText]="band.showAllText"
    [showAllRedirect]="band.showAllRedirect"
    [apiMethod]="band.apiMethod"
    (noElements)="handleNoElements($event)"
    [color]="band.color"
    [firstElement]="band.firstElement"
  ></app-horizontal-band>
</div>
